
import Hero from './components/Hero';
import Challenges from './components/Challenges';
import About from './components/About';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import AppDownload from './components/AppDownload';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Challenges />
      <About />
      <Services />
      <WhyUs />
      <AppDownload />
      <Contact />
      <Footer />
    </div>
  );
}
